module.exports = __webpack_public_path__ + "static/media/prosocialcommerce-logo-circle--inactive.fc4d243c.svg";